// Regras PURAS da tela MeuFrete › BID de Frete (épico PO1-2413, H6/H7): prazo,
// quem pode enviar ou recusar, arquivo aceito e a lista de erros de layout da
// planilha modelo devolvida pelo backend. Sem React, sem rede.
import { PARTICIPANTE_UI, fmtDataISO, fmtSiglas, hojeISO, listaSiglas } from "../../Empresa/GoBID/Bids/regras";

export { PARTICIPANTE_UI, fmtDataISO, fmtSiglas, listaSiglas };

export const EXTENSOES = [".xlsx", ".xlsm"];
export const MAX_BYTES = 20 * 1024 * 1024;

// Prazo 'YYYY-MM-DD' vale o dia inteiro.
export function prazoAberto(prazo, hoje) {
  if (!prazo) return false;
  const h = hoje || hojeISO();
  return String(prazo).slice(0, 10) >= h;
}

export function diasParaPrazo(prazo, hoje) {
  if (!prazo) return null;
  const a = new Date(`${hoje || hojeISO()}T00:00:00`);
  const b = new Date(`${String(prazo).slice(0, 10)}T00:00:00`);
  return Math.round((b.getTime() - a.getTime()) / 86400000);
}

const FECHADOS = ["RECUSOU", "EXPIRADO"];

// Envio/reenvio da planilha até o prazo; o backend pode mandar `podeEnviar`.
export function podeEnviar(bid, hoje) {
  if (!bid) return false;
  if (bid.podeEnviar === false) return false;
  if (FECHADOS.indexOf(bid.estado) !== -1) return false;
  if (bid.situacao && bid.situacao !== "PUBLICADO") return false;
  return prazoAberto(bid.prazoPropostas, hoje);
}

export function podeRecusar(bid, hoje) {
  return podeEnviar(bid, hoje) && bid.estado !== "ENVIOU";
}

export function arquivoValido(arquivo) {
  if (!arquivo) return "Escolha a planilha modelo.";
  const nome = String(arquivo.name || "").toLowerCase();
  if (!EXTENSOES.some((e) => nome.endsWith(e))) return "Envie a planilha modelo do BID (.xlsx ou .xlsm).";
  if (arquivo.size > MAX_BYTES) return "A planilha passa de 20 MB.";
  return null;
}

// 400 `planilha_invalida`: { error, erros:[{ aba, linha, coluna, mensagem }] }
// (aceita também `errors` como lista ou mapa).
export function errosPlanilha(err) {
  const d = (err && err.response && err.response.data) || {};
  let lista = d.erros || d.errosLayout || d.errors || [];
  if (!Array.isArray(lista) && lista && typeof lista === "object") lista = Object.keys(lista).map((k) => ({ campo: k, mensagem: lista[k] }));
  return (lista || []).map((e) => {
    if (typeof e === "string") return { texto: e };
    const onde = [e.aba, e.linha != null ? `linha ${e.linha}` : null, e.coluna ? `coluna ${e.coluna}` : null, e.campo].filter(Boolean).join(" · ");
    return { texto: `${onde ? `${onde}: ` : ""}${e.mensagem || e.message || e.erro || ""}` };
  });
}

export function matchesSearch(item, termo) {
  if (!termo) return true;
  const alvo = String(termo).toLowerCase();
  return [item.nome, item.embarcadorNome, item.embarcador, item.ufs].some((c) => c && String(c).toLowerCase().indexOf(alvo) !== -1);
}

export function nomeEmbarcador(item) {
  return (item && (item.embarcadorNome || item.embarcador || item.embarcadorFantasia)) || "—";
}
